var map = {
	"./1.1.jpg": "38c2",
	"./1.10.pH.png": "3b84",
	"./1.2.TN.png": "5b89",
	"./1.3.TP.png": "61ee",
	"./1.4.NH3-N.png": "71a3",
	"./1.5.COD.png": "30ec",
	"./1.6.CODm.png": "a0c9",
	"./1.7.Chla.png": "692a",
	"./1.8.TSS.png": "a951",
	"./1.9.TU.png": "8e5f",
	"./10.1.jpg": "4e96",
	"./10.10.pH.png": "f23f",
	"./10.2.TN.png": "7ece",
	"./10.3.TP.png": "f855",
	"./10.4.NH3-N.png": "a3d9",
	"./10.5.COD.png": "0acb",
	"./10.6.CODm.png": "676a",
	"./10.7.Chla.png": "fe09",
	"./10.8.TSS.png": "6080",
	"./10.9.TU.png": "c62a",
	"./100.1.jpg": "c045",
	"./100.10.png": "2671",
	"./100.2.png": "a658",
	"./100.3.png": "d382",
	"./100.4.png": "7d68",
	"./100.5.png": "3a8d",
	"./100.6.png": "a483",
	"./100.7.png": "e671",
	"./100.8.png": "c60a",
	"./100.9.png": "8ec1",
	"./101.1.jpg": "5d1c",
	"./101.10.png": "aa28",
	"./101.2.png": "1a2f",
	"./101.3.png": "c281",
	"./101.4.png": "0d5b",
	"./101.5.png": "b9c1",
	"./101.6.png": "50f3",
	"./101.7.png": "ba5e",
	"./101.8.png": "9b48",
	"./101.9.png": "a195",
	"./102.1.jpg": "8cc8",
	"./102.10.png": "0d50",
	"./102.2.png": "649e",
	"./102.3.png": "9219",
	"./102.4.png": "7b72",
	"./102.5.png": "824a",
	"./102.6.png": "69fb",
	"./102.7.png": "24dd",
	"./102.8.png": "a6a4",
	"./102.9.png": "6880",
	"./103.1.jpg": "2340",
	"./103.10.png": "4adf",
	"./103.2.png": "70ce",
	"./103.3.png": "bc62",
	"./103.4.png": "ea56",
	"./103.5.png": "8a17",
	"./103.6.png": "9c2d",
	"./103.7.png": "4b3d",
	"./103.8.png": "6521",
	"./103.9.png": "1619",
	"./104.1.jpg": "5f86",
	"./104.10.png": "27195",
	"./104.2.png": "28d5",
	"./104.3.png": "14c7",
	"./104.4.png": "cf08",
	"./104.5.png": "3e33",
	"./104.6.png": "ef4c",
	"./104.7.png": "baf2",
	"./104.8.png": "fb0c",
	"./104.9.png": "44cd",
	"./105.1.jpg": "d259",
	"./105.10.png": "5927",
	"./105.2.png": "214a",
	"./105.3.png": "b7b3",
	"./105.4.png": "e83d",
	"./105.5.png": "83cb",
	"./105.6.png": "e2f0",
	"./105.7.png": "2b7c",
	"./105.8.png": "cc63",
	"./105.9.png": "3d53",
	"./106.1.jpg": "8c9c",
	"./106.10.png": "cf74",
	"./106.2.png": "ad2d",
	"./106.3.png": "e21d",
	"./106.4.png": "e9bc",
	"./106.5.png": "a2f3",
	"./106.6.png": "2db2",
	"./106.7.png": "825d",
	"./106.8.png": "8e30",
	"./106.9.png": "3bdf",
	"./107.1.jpg": "1328",
	"./107.10.png": "aac8",
	"./107.2.png": "7c48",
	"./107.3.png": "a7fa",
	"./107.4.png": "07e7",
	"./107.5.png": "4b1c",
	"./107.6.png": "b855",
	"./107.7.png": "d9c1",
	"./107.8.png": "e9591",
	"./107.9.png": "1e54",
	"./108.1.jpg": "e654",
	"./108.10.png": "7824",
	"./108.2.png": "d3ae",
	"./108.3.png": "a161",
	"./108.4.png": "c5ed",
	"./108.5.png": "3dbc",
	"./108.6.png": "7832",
	"./108.7.png": "9ecb",
	"./108.8.png": "e3c1",
	"./108.9.png": "9749",
	"./109.1.jpg": "e4bd",
	"./109.10.png": "3f76",
	"./109.2.png": "a383",
	"./109.3.png": "332b",
	"./109.4.png": "7b8e",
	"./109.5.png": "86ae",
	"./109.6.png": "23cc",
	"./109.7.png": "1567",
	"./109.8.png": "09c2",
	"./109.9.png": "916d",
	"./11.1.jpg": "5f17",
	"./11.10.pH.png": "c77f",
	"./11.2.TN.png": "1bc6",
	"./11.3.TP.png": "2880",
	"./11.4.NH3-N.png": "2099",
	"./11.5.COD.png": "6c8c",
	"./11.6.CODm.png": "a584",
	"./11.7.Chla.png": "6b9f",
	"./11.8.TSS.png": "28fa",
	"./11.9.TU.png": "f8be",
	"./110.1.jpg": "3db6",
	"./110.10.png": "65be",
	"./110.2.png": "990c",
	"./110.3.png": "57c2",
	"./110.4.png": "a766",
	"./110.5.png": "0fcc",
	"./110.6.png": "5fa3",
	"./110.7.png": "d9a3",
	"./110.8.png": "691e",
	"./110.9.png": "1dec",
	"./111.1.jpg": "102f",
	"./111.10.png": "7f33",
	"./111.2.png": "ee43",
	"./111.3.png": "e863",
	"./111.4.png": "9451",
	"./111.5.png": "ccca",
	"./111.6.png": "6f74",
	"./111.7.png": "80b8",
	"./111.8.png": "e5a8",
	"./111.9.png": "c31f",
	"./112.1.jpg": "c440",
	"./112.10.png": "a157",
	"./112.2.png": "cbce",
	"./112.3.png": "7625",
	"./112.4.png": "7a60",
	"./112.5.png": "5a71",
	"./112.6.png": "f5aa",
	"./112.7.png": "47dc",
	"./112.8.png": "73ec",
	"./112.9.png": "5a7b",
	"./113.1.jpg": "f7a7",
	"./113.10.png": "bcf0",
	"./113.2.png": "b94d",
	"./113.3.png": "4d28",
	"./113.4.png": "41b5",
	"./113.5.png": "a00b",
	"./113.6.png": "68ae",
	"./113.7.png": "25c9",
	"./113.8.png": "894f",
	"./113.9.png": "6fea",
	"./114.1.jpg": "466c",
	"./114.10.png": "c1fa",
	"./114.2.png": "0b79",
	"./114.3.png": "a8a8",
	"./114.4.png": "f52c",
	"./114.5.png": "66c7",
	"./114.6.png": "e158",
	"./114.7.png": "0b5b",
	"./114.8.png": "e58a",
	"./114.9.png": "e9a3",
	"./115.1.jpg": "7aa9",
	"./115.10.png": "cc60",
	"./115.2.png": "7318",
	"./115.3.png": "0447",
	"./115.4.png": "100c",
	"./115.5.png": "ab69",
	"./115.6.png": "a323",
	"./115.7.png": "fc1b",
	"./115.8.png": "6b2c",
	"./115.9.png": "9a0c",
	"./116.1.jpg": "1dc0",
	"./116.10.png": "e886",
	"./116.2.png": "e58f",
	"./116.3.png": "fe86",
	"./116.4.png": "40a1",
	"./116.5.png": "31ed",
	"./116.6.png": "6130",
	"./116.7.png": "966c",
	"./116.8.png": "a4cc",
	"./116.9.png": "0260",
	"./117.1.jpg": "f54d",
	"./117.10.png": "d0a9",
	"./117.2.png": "0551",
	"./117.3.png": "607d0",
	"./117.4.png": "0f20",
	"./117.5.png": "2a99",
	"./117.6.png": "04f1",
	"./117.7.png": "ca08",
	"./117.8.png": "17c4",
	"./117.9.png": "9063",
	"./118.1.jpg": "ef7d",
	"./118.10.png": "1ad2",
	"./118.2.png": "168a",
	"./118.3.png": "539d",
	"./118.4.png": "c252",
	"./118.5.png": "11d5",
	"./118.6.png": "94c2",
	"./118.7.png": "80f0a",
	"./118.8.png": "db4c",
	"./118.9.png": "7bcf",
	"./119.1.jpg": "2b64",
	"./119.10.png": "33ee",
	"./119.2.png": "b717",
	"./119.3.png": "509c",
	"./119.4.png": "8afd",
	"./119.5.png": "abc2",
	"./119.6.png": "d08e",
	"./119.7.png": "6afa",
	"./119.8.png": "b8c2",
	"./119.9.png": "d371",
	"./12.1.jpg": "9590",
	"./12.10.pH.png": "189c",
	"./12.2.TN.png": "b65a",
	"./12.3.TP.png": "4b8e",
	"./12.4.NH3-N.png": "4223",
	"./12.5.COD.png": "ad8e",
	"./12.6.CODm.png": "b4cc",
	"./12.7.Chla.png": "b0e2",
	"./12.8.TSS.png": "0f36",
	"./12.9.TU.png": "1d0c",
	"./120.1.jpg": "0d54",
	"./120.10.png": "98a1",
	"./120.2.png": "5895",
	"./120.3.png": "5114",
	"./120.4.png": "3b32",
	"./120.5.png": "f1a0",
	"./120.6.png": "0fcf",
	"./120.7.png": "7e48",
	"./120.8.png": "d750",
	"./120.9.png": "45fe",
	"./121.1.jpg": "37ae",
	"./121.10.png": "654b",
	"./121.2.png": "4648",
	"./121.3.png": "d581",
	"./121.4.png": "4703",
	"./121.5.png": "00fc",
	"./121.6.png": "aa91",
	"./121.7.png": "5ce8",
	"./121.8.png": "8a94",
	"./121.9.png": "e981",
	"./122.1.jpg": "ac0d",
	"./122.10.png": "5f41",
	"./122.2.png": "3b98",
	"./122.3.png": "a0c5",
	"./122.4.png": "a0a9",
	"./122.5.png": "88f4",
	"./122.6.png": "d104",
	"./122.7.png": "f6a1",
	"./122.8.png": "c86d",
	"./122.9.png": "7aec",
	"./123.1.jpg": "6b74",
	"./123.10.png": "49306",
	"./123.2.png": "c715",
	"./123.3.png": "bda8",
	"./123.4.png": "8401",
	"./123.5.png": "a1b8",
	"./123.6.png": "2363",
	"./123.7.png": "587b",
	"./123.8.png": "1a24",
	"./123.9.png": "5aef",
	"./124.1.jpg": "74b6",
	"./124.10.png": "c723",
	"./124.2.png": "56ce",
	"./124.3.png": "0c90",
	"./124.4.png": "9251",
	"./124.5.png": "798e",
	"./124.6.png": "3ce0",
	"./124.7.png": "c8b3",
	"./124.8.png": "1810",
	"./124.9.png": "60f6",
	"./125.1.jpg": "f1ce",
	"./125.10.png": "d176",
	"./125.2.png": "b303",
	"./125.3.png": "dfd1",
	"./125.4.png": "5284",
	"./125.5.png": "9294",
	"./125.6.png": "7714",
	"./125.7.png": "6363",
	"./125.8.png": "7409",
	"./125.9.png": "2344",
	"./126.1.jpg": "7307",
	"./126.10.png": "7b6c",
	"./126.2.png": "eeb8",
	"./126.3.png": "96c0",
	"./126.4.png": "1988",
	"./126.5.png": "8c35",
	"./126.6.png": "e34b",
	"./126.7.png": "7e3a",
	"./126.8.png": "114b",
	"./126.9.png": "4297",
	"./127.1.jpg": "ec61",
	"./127.10.png": "0e1c",
	"./127.2.png": "4d9f",
	"./127.3.png": "6adf",
	"./127.4.png": "e2fe",
	"./127.5.png": "d901",
	"./127.6.png": "71ac",
	"./127.7.png": "9d72",
	"./127.8.png": "cef1",
	"./127.9.png": "3513",
	"./128.1.jpg": "fa3c",
	"./128.10.png": "d456",
	"./128.2.png": "6e0f",
	"./128.3.png": "3f2e",
	"./128.4.png": "fac0",
	"./128.5.png": "bc4f",
	"./128.6.png": "1899",
	"./128.7.png": "f177",
	"./128.8.png": "cede",
	"./128.9.png": "54a4",
	"./129.1.jpg": "e207",
	"./129.10.png": "0d5c",
	"./129.2.png": "6d37",
	"./129.3.png": "c7b6",
	"./129.4.png": "9282",
	"./129.5.png": "38427",
	"./129.6.png": "4579",
	"./129.7.png": "ec6e",
	"./129.8.png": "0b00",
	"./129.9.png": "2420",
	"./13.1.jpg": "b265",
	"./13.10.pH.png": "aa71",
	"./13.2.TN.png": "6baa",
	"./13.3.TP.png": "9fba",
	"./13.4.NH3-N.png": "e173",
	"./13.5.COD.png": "9609",
	"./13.6.CODm.png": "ae7d",
	"./13.7.Chla.png": "6915",
	"./13.8.TSS.png": "4c43",
	"./13.9.TU.png": "dc14",
	"./130.1.jpg": "c18a",
	"./130.10.png": "de92",
	"./130.2.png": "0df9",
	"./130.3.png": "5b90",
	"./130.4.png": "b14d",
	"./130.5.png": "7daa",
	"./130.6.png": "e56c",
	"./130.7.png": "2eca",
	"./130.8.png": "4798",
	"./130.9.png": "547d",
	"./131.1.jpg": "dfa6",
	"./131.10.png": "1158",
	"./131.2.png": "f33c",
	"./131.3.png": "2052",
	"./131.4.png": "17c7",
	"./131.5.png": "86ba",
	"./131.6.png": "0789",
	"./131.7.png": "1ca7",
	"./131.8.png": "40ab",
	"./131.9.png": "42fd",
	"./132.1.jpg": "e241",
	"./132.10.png": "9668",
	"./132.2.png": "eeec",
	"./132.3.png": "a72f",
	"./132.4.png": "5afc",
	"./132.5.png": "9b1a",
	"./132.6.png": "7c85",
	"./132.7.png": "7fcf",
	"./132.8.png": "c958",
	"./132.9.png": "45a4",
	"./133.1.jpg": "b088",
	"./133.10.png": "bd37",
	"./133.2.png": "2379",
	"./133.3.png": "4de6",
	"./133.4.png": "d60c",
	"./133.5.png": "41a3",
	"./133.6.png": "6d9a",
	"./133.7.png": "a795",
	"./133.8.png": "1f9e",
	"./133.9.png": "1b0d",
	"./134.1.jpg": "9deb",
	"./134.10.png": "d032",
	"./134.2.png": "82d9",
	"./134.3.png": "bdc9",
	"./134.4.png": "318a",
	"./134.5.png": "2581",
	"./134.6.png": "1a4f",
	"./134.7.png": "e3e5",
	"./134.8.png": "6f44",
	"./134.9.png": "21a5",
	"./135.1.jpg": "b162",
	"./135.10.png": "c9d5",
	"./135.2.png": "dda9",
	"./135.3.png": "17c26",
	"./135.4.png": "2f629",
	"./135.5.png": "e862",
	"./135.6.png": "0a9d",
	"./135.7.png": "1d94",
	"./135.8.png": "bd35",
	"./135.9.png": "607a",
	"./136.1.jpg": "52fa",
	"./136.10.png": "4152",
	"./136.2.png": "7295",
	"./136.3.png": "a5ef",
	"./136.4.png": "6a0f",
	"./136.5.png": "7842",
	"./136.6.png": "8a87",
	"./136.7.png": "68f4",
	"./136.8.png": "298a",
	"./136.9.png": "4378",
	"./137.1.jpg": "ddcc",
	"./137.10.png": "3f71",
	"./137.2.png": "d085",
	"./137.3.png": "5bdf",
	"./137.4.png": "2f9b",
	"./137.5.png": "730c",
	"./137.6.png": "8bba",
	"./137.7.png": "2e6e",
	"./137.8.png": "624c",
	"./137.9.png": "f57c",
	"./138.1.jpg": "1e29",
	"./138.10.png": "44dd",
	"./138.2.png": "5f63",
	"./138.3.png": "ca41",
	"./138.4.png": "0597",
	"./138.5.png": "8d98",
	"./138.6.png": "f7dc7",
	"./138.7.png": "c5f8",
	"./138.8.png": "c040",
	"./138.9.png": "bd93",
	"./139.1.jpg": "361c",
	"./139.10.png": "0e09",
	"./139.2.png": "7c3b",
	"./139.3.png": "35e6",
	"./139.4.png": "4140",
	"./139.5.png": "815e",
	"./139.6.png": "d6c3",
	"./139.7.png": "c7ec",
	"./139.8.png": "42f1",
	"./139.9.png": "5b00",
	"./14.1.jpg": "42f13",
	"./14.10.pH.png": "e378",
	"./14.2.TN.png": "44eb",
	"./14.3.TP.png": "0fad",
	"./14.4.NH3-N.png": "b80f",
	"./14.5.COD.png": "75d5",
	"./14.6.CODm.png": "539f",
	"./14.7.Chla.png": "c915",
	"./14.8.TSS.png": "1c9d",
	"./14.9.TU.png": "2d57",
	"./140.1.jpg": "595a",
	"./140.10.png": "1a45",
	"./140.2.png": "0ceb",
	"./140.3.png": "6294",
	"./140.4.png": "9097",
	"./140.5.png": "962e",
	"./140.6.png": "d013",
	"./140.7.png": "3757",
	"./140.8.png": "22aa",
	"./140.9.png": "1cb5",
	"./141.1.jpg": "2e2f",
	"./141.10.png": "7ce4",
	"./141.2.png": "9d45",
	"./141.3.png": "25ae",
	"./141.4.png": "7cf2",
	"./141.5.png": "2563",
	"./141.6.png": "479a",
	"./141.7.png": "8b0e",
	"./141.8.png": "c29c",
	"./141.9.png": "e5d9",
	"./142.1.jpg": "c498",
	"./142.10.png": "92aa",
	"./142.2.png": "d713",
	"./142.3.png": "6d87",
	"./142.4.png": "d763",
	"./142.5.png": "4a5f",
	"./142.6.png": "67f2",
	"./142.7.png": "ef2a",
	"./142.8.png": "a732",
	"./142.9.png": "40c1",
	"./143.1.jpg": "2061",
	"./143.10.png": "930a",
	"./143.2.png": "74f7",
	"./143.3.png": "de11",
	"./143.4.png": "5466",
	"./143.5.png": "6f27",
	"./143.6.png": "734d",
	"./143.7.png": "7f68",
	"./143.8.png": "22a9",
	"./143.9.png": "8118",
	"./144.1.jpg": "3867",
	"./144.10.png": "72f2",
	"./144.2.png": "70d6",
	"./144.3.png": "695d",
	"./144.4.png": "2510",
	"./144.5.png": "2659",
	"./144.6.png": "9864",
	"./144.7.png": "3905",
	"./144.8.png": "5d98",
	"./144.9.png": "c02d",
	"./145.1.jpg": "69a1",
	"./145.10.png": "7ff3",
	"./145.2.png": "225f",
	"./145.3.png": "504f",
	"./145.4.png": "ea54",
	"./145.5.png": "ad8c",
	"./145.6.png": "3b1c",
	"./145.7.png": "b028",
	"./145.8.png": "d3fa",
	"./145.9.png": "a9fb",
	"./146.1.jpg": "01da",
	"./146.10.png": "6dd1",
	"./146.2.png": "fd4d",
	"./146.3.png": "cb6f",
	"./146.4.png": "2f54",
	"./146.5.png": "efe7",
	"./146.6.png": "e5bf",
	"./146.7.png": "7f1b",
	"./146.8.png": "64f2",
	"./146.9.png": "fbc5",
	"./15.1.jpg": "3303",
	"./15.10.pH.png": "a059",
	"./15.2.TN.png": "ee2e",
	"./15.3.TP.png": "8707",
	"./15.4.NH3-N.png": "6ccb",
	"./15.5.COD.png": "b437",
	"./15.6.CODm.png": "97423",
	"./15.7.Chla.png": "c4a4",
	"./15.8.TSS.png": "170e",
	"./15.9.TU.png": "cd88",
	"./16.1.jpg": "955b",
	"./16.10.pH.png": "5ea3",
	"./16.2.TN.png": "b41b",
	"./16.3.TP.png": "66f9",
	"./16.4.NH3-N.png": "adfa",
	"./16.5.COD.png": "dc4a",
	"./16.6.CODm.png": "1c86",
	"./16.7.Chla.png": "c2dd",
	"./16.8.TSS.png": "7b5b",
	"./16.9.TU.png": "1719",
	"./17.1.jpg": "7d80",
	"./17.10.pH.png": "2894",
	"./17.2.TN.png": "cea8",
	"./17.3.TP.png": "2fa7",
	"./17.4.NH3-N.png": "9178",
	"./17.5COD.png": "8dcb",
	"./17.6.CODm.png": "bd50",
	"./17.7.Chla.png": "321d",
	"./17.8.TSS.png": "6937",
	"./17.9.TU.png": "7a16",
	"./18.1.jpg": "d74e",
	"./18.10.pH.png": "62aa",
	"./18.2.TN.png": "bc77",
	"./18.3.TP.png": "cb4a",
	"./18.4.NH3-N.png": "59e0",
	"./18.5.COD.png": "f7ac",
	"./18.6.CODm.png": "a18d",
	"./18.7.Chla.png": "44c1",
	"./18.8.TSS.png": "f280",
	"./18.9.TU.png": "bd03",
	"./19.1.jpg": "7856",
	"./19.10.pH.png": "e915",
	"./19.2.TN.png": "95a5",
	"./19.3.TP.png": "755c",
	"./19.4.NH3-N.png": "bdb7",
	"./19.5.COD.png": "8c63",
	"./19.6.CODm.png": "9351",
	"./19.7.Chla.png": "c7c0",
	"./19.8.TSS.png": "f988",
	"./19.9.TU.png": "1ba0",
	"./2.1.jpg": "13c2",
	"./2.10.pH.png": "d0a8",
	"./2.2.TN.png": "0a19",
	"./2.3.TP.png": "c28a",
	"./2.4.NH3-N.png": "082a",
	"./2.5.COD.png": "5e98",
	"./2.6.CODm.png": "daf1",
	"./2.7.Chla.png": "181b",
	"./2.8.TSS.png": "5502",
	"./2.9.TU.png": "de10",
	"./20.1.jpg": "6eed",
	"./20.10.pH.png": "bbef",
	"./20.2.TN.png": "0468",
	"./20.3.TP.png": "7213",
	"./20.4.NH3-N.png": "110a",
	"./20.5.COD.png": "f733",
	"./20.6.CODm.png": "82ad",
	"./20.7.Chla.png": "ad15",
	"./20.8.TSS.png": "697f",
	"./20.9.TU.png": "ddd5",
	"./21.1.jpg": "0f14",
	"./21.10.pH.png": "75e2",
	"./21.2.TN.png": "8955",
	"./21.3.TP.png": "4476",
	"./21.4.NH3-N.png": "c3d5",
	"./21.5.COD.png": "7a27",
	"./21.6.CODm .png": "18a0",
	"./21.7.Chla.png": "cc5c",
	"./21.8.TSS.png": "a254",
	"./21.9.TU.png": "da9c",
	"./22.1.jpg": "046b",
	"./22.10.pH.png": "ddfb",
	"./22.2.TN.png": "ac33",
	"./22.3.TP.png": "5495",
	"./22.4.NH3-N.png": "7819",
	"./22.5.COD.png": "65af",
	"./22.6.CODm.png": "eca3",
	"./22.7.Chla.png": "fd0e",
	"./22.8.TSS.png": "8385",
	"./22.9.TU.png": "9dba",
	"./23.1.jpg": "0130",
	"./23.10.pH.png": "7a30",
	"./23.2.TN.png": "348e",
	"./23.3.TP.png": "b2b3",
	"./23.4.NH3-N.png": "0b9b",
	"./23.5.COD.png": "079b",
	"./23.6.CODm.png": "221e",
	"./23.7.Chla.png": "1a62",
	"./23.8.TSS.png": "1cf2",
	"./23.9.TU.png": "e364",
	"./24.1.jpg": "5f9e",
	"./24.10.pH.png": "c2a3",
	"./24.2.TN.png": "652a",
	"./24.3.TP.png": "6703",
	"./24.4.NH3-N.png": "86e7",
	"./24.5.COD.png": "abcc",
	"./24.6.CODm.png": "97ae",
	"./24.7.Chla.png": "df11",
	"./24.8.TSS.png": "35d5",
	"./24.9.TU.png": "5b32",
	"./25.1.jpg": "dd55",
	"./25.10.pH.png": "42ce",
	"./25.2.TN.png": "1e21",
	"./25.3.TP.png": "12fd",
	"./25.4.NH3-N.png": "307a",
	"./25.5.COD.png": "78d1",
	"./25.6.CODm.png": "157e",
	"./25.7.Chla.png": "0b9e",
	"./25.8.TSS.png": "d843",
	"./25.9.TU.png": "934e",
	"./26.1.jpg": "0c27",
	"./26.10.pH.png": "563f",
	"./26.2.TN.png": "ee1b",
	"./26.3.TP.png": "9545",
	"./26.4.NH3-N.png": "ebb1",
	"./26.5.COD.png": "ed2d",
	"./26.6.CODm.png": "f7dd",
	"./26.7.Chla.png": "0be8",
	"./26.8.TSS.png": "4ded",
	"./26.9.TU.png": "0926",
	"./27.1.jpg": "c5cc",
	"./27.10.pH.png": "35d4",
	"./27.2.TN.png": "1cb9",
	"./27.3.TP.png": "af6c",
	"./27.4.NH3-N.png": "442e",
	"./27.5.COD.png": "9d49",
	"./27.6.CODm.png": "419a",
	"./27.7.Chla.png": "b417",
	"./27.8.TSS.png": "98ab",
	"./27.9.TU.png": "6770",
	"./28.1.jpg": "9b0f",
	"./28.10.pH.png": "2ca4",
	"./28.2.TN.png": "afc3",
	"./28.3.TP.png": "76d6",
	"./28.4.NH3-N.png": "4c07",
	"./28.5.COD.png": "29f0",
	"./28.6.CODm.png": "f3425",
	"./28.7.Chla.png": "4b0a",
	"./28.8.TSS.png": "9797",
	"./28.9.TU.png": "2d88",
	"./29.1.jpg": "79ab",
	"./29.10.pH.png": "9773",
	"./29.2.TN.png": "ac97",
	"./29.3.TP.png": "1e5c",
	"./29.4.NH3-N.png": "0b4f",
	"./29.5.COD.png": "40d1",
	"./29.6.CODm.png": "919e",
	"./29.7.Chla.png": "6ebb",
	"./29.8.TSS.png": "c85b",
	"./29.9.TU.png": "900f",
	"./3.1.jpg": "9f85",
	"./3.10.pH.png": "03f7",
	"./3.2.TN.png": "2d2c",
	"./3.3.TP.png": "4606",
	"./3.4.NH3-N.png": "01a8",
	"./3.5.COD.png": "bf58",
	"./3.6.CODm.png": "533e",
	"./3.7.Chla.png": "f0b6",
	"./3.8.TSS.png": "cb0c",
	"./3.9.TU.png": "6441",
	"./30.1.jpg": "f20f",
	"./30.10.pH.png": "1d48",
	"./30.2.TN.png": "5fa30",
	"./30.3.TP.png": "047e",
	"./30.4.NH3-N.png": "6b20",
	"./30.5.COD.png": "c145",
	"./30.6.CODm.png": "e038",
	"./30.7.Chla.png": "2195",
	"./30.8.TSS.png": "8772",
	"./30.9.TU.png": "bb4c",
	"./31.1.jpg": "63f7",
	"./31.10.pH.png": "bfaf",
	"./31.2.TN.png": "ec64",
	"./31.3.TP.png": "623c",
	"./31.4.NH3-N.png": "497f",
	"./31.5.COD.png": "01d1",
	"./31.6.CODm.png": "b1bd",
	"./31.7.Chla.png": "e6e6",
	"./31.8.TSS.png": "7703",
	"./31.9.TU.png": "7309",
	"./32.1.jpg": "ca418",
	"./32.10.pH.png": "0f3d",
	"./32.2.TN.png": "f261",
	"./32.3.TP.png": "8717",
	"./32.4.NH3-N.png": "b50e",
	"./32.5.COD.png": "898d",
	"./32.6.CODm.png": "d6ba",
	"./32.7.Chla.png": "4cfc",
	"./32.8.TSS.png": "0aef",
	"./32.9.TU.png": "39ac",
	"./33.1.jpg": "ba35",
	"./33.10.pH.png": "9f21",
	"./33.2.TN.png": "c153",
	"./33.3.TP.png": "2faf",
	"./33.4.NH3-N.png": "a53b",
	"./33.5.COD.png": "ba34",
	"./33.6.CODm.png": "0e0e",
	"./33.7.Chla.png": "b3e0",
	"./33.8.TSS.png": "201c",
	"./33.9.TU.png": "5917",
	"./34.1.jpg": "ae9c",
	"./34.10.pH.png": "f9c2",
	"./34.2.TN.png": "9809",
	"./34.3.TP.png": "883c",
	"./34.4.NH3-N.png": "b745",
	"./34.5.COD.png": "d29b",
	"./34.6.CODm.png": "6ff2",
	"./34.7.Chla.png": "4743",
	"./34.8.TSS.png": "e636",
	"./34.9.TU.png": "1467",
	"./35.1.jpg": "e6bb",
	"./35.10.pH.png": "49ef",
	"./35.2.TN.png": "8943",
	"./35.3.TP.png": "c90e",
	"./35.4.NH3-N.png": "c4f4",
	"./35.5.COD.png": "6791",
	"./35.6.CODm.png": "274f",
	"./35.7.Chla.png": "f894",
	"./35.8.TSS.png": "aca1",
	"./35.9.TU.png": "a82e",
	"./36.1.jpg": "3ec2",
	"./36.10.pH.png": "a68e",
	"./36.2.TN.png": "be20",
	"./36.3.TP.png": "2c9c",
	"./36.4.NH3-N.png": "8e66",
	"./36.5.COD.png": "2971",
	"./36.6.CODm.png": "c521",
	"./36.7.Chla.png": "b48a",
	"./36.8.TSS.png": "e1fb",
	"./36.9.TU.png": "446d",
	"./37.1.jpg": "3293",
	"./37.10.pH.png": "c0af",
	"./37.2.TN.png": "8081",
	"./37.3.TP.png": "36f0",
	"./37.4.NH3-N.png": "370c",
	"./37.5.COD.png": "f534",
	"./37.6.CODm.png": "1979",
	"./37.7.Chla.png": "ef976",
	"./37.8.TSS.png": "c3cb",
	"./37.9.TU.png": "7326",
	"./38.1.jpg": "728f",
	"./38.10.pH.png": "1b54",
	"./38.2.TN.png": "f843",
	"./38.3.TP.png": "a8f7",
	"./38.4.NH3-N.png": "0308",
	"./38.5.COD.png": "4366",
	"./38.6.CODm.png": "e07b",
	"./38.7.Chla.png": "83a6",
	"./38.8.TSS.png": "7955",
	"./38.9.TU.png": "dbd0",
	"./39.1.jpg": "df23",
	"./39.10.pH.png": "39ce",
	"./39.2.TN.png": "3e4e",
	"./39.3.TP.png": "5dd8",
	"./39.4.NH3-N.png": "5a3c",
	"./39.5.COD.png": "609d",
	"./39.6.CODm.png": "8947",
	"./39.7.Chla.png": "b111",
	"./39.8.TSS.png": "aaf1",
	"./39.9.TU.png": "3b9b",
	"./4.1.jpg": "3163",
	"./4.10.pH.png": "1bda",
	"./4.2.TN.png": "c9a8",
	"./4.3.TP.png": "aa65",
	"./4.4.NH3-N.png": "6804",
	"./4.5.COD.png": "fe63",
	"./4.6.CODm.png": "4c6d",
	"./4.7.Chla.png": "b6d3",
	"./4.8.TSS.png": "7d83",
	"./4.9.TU.png": "d653",
	"./40.1.jpg": "1817",
	"./40.10.pH.png": "faf57",
	"./40.2.TN.png": "68e5",
	"./40.3.TP.png": "8981",
	"./40.4.NH3-N.png": "53f0",
	"./40.5.COD.png": "1bec",
	"./40.6.CODm.png": "0a47",
	"./40.7.Chla.png": "9931",
	"./40.8.TSS.png": "d779",
	"./40.9.TU.png": "e44b",
	"./41.1.jpg": "fa39",
	"./41.10.pH.png": "ff56",
	"./41.2.TN.png": "0711",
	"./41.3.TP.png": "7aaf",
	"./41.4.NH3-N.png": "1509",
	"./41.5.COD.png": "7bd7",
	"./41.6.CODm.png": "8c44",
	"./41.7.Chla.png": "5529",
	"./41.8.TSS.png": "b94e",
	"./41.9.TU.png": "0051",
	"./42.1.jpg": "287e",
	"./42.10.pH.png": "9cd8",
	"./42.2.TN.png": "3c6c",
	"./42.3.TP.png": "8b60",
	"./42.4.NH3-N.png": "e231",
	"./42.5.COD.png": "1e63",
	"./42.6.CODm.png": "5eb8",
	"./42.7.Chla.png": "06ea",
	"./42.8.TSS.png": "2da5",
	"./42.9.TU.png": "322a",
	"./43.1.jpg": "b525",
	"./43.10.pH.png": "acc5",
	"./43.2.TN.png": "0012",
	"./43.3.TP.png": "a06f",
	"./43.4.NH3-N.png": "1e1b",
	"./43.5.COD.png": "39b2",
	"./43.6.CODm.png": "dfb4",
	"./43.7.Chla.png": "8563",
	"./43.8.TSS.png": "35a0",
	"./43.9.TU.png": "5c87",
	"./44.1.jpg": "1dc5",
	"./44.10.pH.png": "fbd0",
	"./44.2.TN.png": "5c41",
	"./44.3.TP.png": "14b9",
	"./44.4.NH3-N.png": "a5bb",
	"./44.5.COD.png": "fa96",
	"./44.6.CODm.png": "7392",
	"./44.7.Chla.png": "13b4",
	"./44.8.TSS.png": "404e",
	"./44.9.TU.png": "63f2",
	"./45.1.jpg": "3701",
	"./45.10.pH.png": "c8b3d",
	"./45.2.TN.png": "9ef6",
	"./45.3.TP.png": "2b4d",
	"./45.4.NH3-N.png": "568f",
	"./45.5.COD.png": "1cc8",
	"./45.6.CODm.png": "4773",
	"./45.7.Chla.png": "94c5",
	"./45.8.TSS.png": "aa65d",
	"./45.9.TU.png": "f10f",
	"./46.1.jpg": "d828",
	"./46.10.pH.png": "f576",
	"./46.2.TN.png": "41b0",
	"./46.3.TP.png": "0de1",
	"./46.4.NH3-N.png": "4641",
	"./46.5.COD.png": "18ee",
	"./46.6.CODm.png": "5ac9",
	"./46.7.Chla.png": "747a",
	"./46.8.TSS.png": "3a73",
	"./46.9.TU.png": "89d7",
	"./47.1.jpg": "d8b2",
	"./47.10.pH.png": "ea94",
	"./47.2.TN.png": "36e1",
	"./47.3.TP.png": "4162",
	"./47.4.NH3-N.png": "3ec0",
	"./47.5.COD.png": "1cb3",
	"./47.6.CODm.png": "873d",
	"./47.7.Chla.png": "9d74",
	"./47.8.TSS.png": "b521",
	"./47.9.TU.png": "c556",
	"./48.1.jpg": "f810",
	"./48.10.pH.png": "4c8f",
	"./48.11.png": "c71d",
	"./48.2.TN.png": "764f",
	"./48.3.TP.png": "7b99",
	"./48.4.NH3-N.png": "0ad0",
	"./48.5.COD.png": "cc14",
	"./48.6.CODm.png": "4b71",
	"./48.7.Chla.png": "8aca",
	"./48.8.TSS.png": "0aa0",
	"./48.9.TU.png": "f840",
	"./49.1.jpg": "b8c5",
	"./49.10.pH.png": "81d1",
	"./49.2.TN.png": "a376",
	"./49.3.TP.png": "dbcc",
	"./49.4.NH3-N.png": "d487",
	"./49.5.COD.png": "4c03",
	"./49.6.CODm.png": "fa02",
	"./49.7.Chla.png": "98b1",
	"./49.8.TSS.png": "e2b4",
	"./49.9.TU.png": "ed32",
	"./5.1.jpg": "c634",
	"./5.10.pH.png": "4614",
	"./5.2.TN.png": "610a",
	"./5.3.TP.png": "51f3",
	"./5.4.NH3-N.png": "acbe",
	"./5.5.COD.png": "4a6a",
	"./5.6.CODm.png": "7c67",
	"./5.7.Chla.png": "e1f6",
	"./5.8.TSS.png": "ab93",
	"./5.9.TU.png": "6fbe",
	"./50.1.jpg": "c4a35",
	"./50.10.pH.png": "7aea",
	"./50.2.TN.png": "f86c",
	"./50.3.TP.png": "706b",
	"./50.4.NH3-N.png": "1784",
	"./50.5.COD.png": "c1d7",
	"./50.6.CODm.png": "6376",
	"./50.7.Chla.png": "7488",
	"./50.8.TSS.png": "6192",
	"./50.9.TU.png": "b1e3",
	"./51.1.jpg": "5355",
	"./51.10.pH.png": "db05",
	"./51.2.TN.png": "7412",
	"./51.3.TP.png": "77b6",
	"./51.4.NH3-N.png": "8b1a0",
	"./51.5.COD.png": "615d",
	"./51.6.CODm.png": "996c",
	"./51.7.Chla.png": "215a",
	"./51.8.TSS.png": "e21c",
	"./51.9.TU.png": "ae90",
	"./52.1.jpg": "7a38",
	"./52.10.pH.png": "00cf",
	"./52.2.TN.png": "26b8",
	"./52.3.TP.png": "7ad5",
	"./52.4.NH3-N.png": "f6bb",
	"./52.5.COD.png": "c625",
	"./52.6.CODm.png": "e568",
	"./52.7.Chla.png": "b73f",
	"./52.8.TSS.png": "827a",
	"./52.9.TU.png": "c83a",
	"./53.1.jpg": "4331",
	"./53.10.pH.png": "59c4",
	"./53.2.TN.png": "1d61",
	"./53.3.TP.png": "2b84",
	"./53.4.NH3-N.png": "f86d",
	"./53.5.COD.png": "27d5",
	"./53.6.CODm.png": "c2f1",
	"./53.7.Chla.png": "04a8",
	"./53.8.TSS.png": "360e",
	"./53.9.TU.png": "dde6",
	"./54.1.jpg": "557c",
	"./54.10.pH.png": "c7eb",
	"./54.2.TN.png": "da85",
	"./54.3.TP.png": "60a9",
	"./54.4.NH3-N.png": "89be",
	"./54.5.COD.png": "3dc8",
	"./54.6.CODm.png": "ecba",
	"./54.7.Chla.png": "e722",
	"./54.8.TSS.png": "93f3",
	"./54.9.TU.png": "0b97",
	"./55.1.jpg": "b2ea",
	"./55.10.pH.png": "9d8c",
	"./55.2.TN.png": "eb07",
	"./55.3.TP.png": "c8e9",
	"./55.4.NH3-N.png": "1d84",
	"./55.5.COD.png": "4edc",
	"./55.6.CODm.png": "6c67",
	"./55.7.Chla.png": "e570",
	"./55.8.TSS.png": "4db9",
	"./55.9.TU.png": "17f7",
	"./56.1.jpg": "7efd",
	"./56.10.pH.png": "e65f",
	"./56.2.TN.png": "c37c",
	"./56.3.TP.png": "66b8",
	"./56.4.NH3-N.png": "a810",
	"./56.5.COD.png": "3769",
	"./56.6.CODm.png": "70cd",
	"./56.7.Chla.png": "3508",
	"./56.8.TSS.png": "5960",
	"./56.9.TU.png": "84e1",
	"./57.1.jpg": "d38c",
	"./57.10.pH.png": "1e67",
	"./57.2.TN.png": "8087",
	"./57.3.TP.png": "04ac",
	"./57.4.NH3-N.png": "c402",
	"./57.5.COD.png": "5acb",
	"./57.6.CODm.png": "1080",
	"./57.7.Chla.png": "061e",
	"./57.8.TSS.png": "2131",
	"./57.9.TU.png": "4e45",
	"./58.1.jpg": "c485",
	"./58.10.pH.png": "47a7",
	"./58.2.TN.png": "a295",
	"./58.3.TP.png": "5a02",
	"./58.4.NH3-N.png": "9ae2",
	"./58.5.COD.png": "ee90",
	"./58.6.CODm.png": "c72a",
	"./58.7.Chla.png": "935d",
	"./58.8.TSS.png": "a523",
	"./58.9.TU.png": "4459",
	"./59.1.jpg": "8bd7",
	"./59.10.pH.png": "4cb8",
	"./59.2.TN.png": "529f",
	"./59.3.TP.png": "a9b0",
	"./59.4.NH3-N.png": "8895",
	"./59.5.COD.png": "5e72",
	"./59.6.CODm.png": "a673",
	"./59.7.Chla.png": "3932",
	"./59.8.TSS.png": "5935",
	"./59.9.TU.png": "7db7",
	"./6.1.jpg": "ac09",
	"./6.10.pH.png": "55e5",
	"./6.2.TN.png": "7f97",
	"./6.3.TP.png": "2a3f",
	"./6.4.NH3-N.png": "2e3f",
	"./6.5.COD.png": "c9b0",
	"./6.6.CODm.png": "8a8c",
	"./6.7.Chla.png": "023b",
	"./6.8.TSS.png": "869d",
	"./6.9.TU.png": "d849",
	"./60.1.jpg": "4bf0",
	"./60.10.pH.png": "77ee",
	"./60.2.TN.png": "aa3f",
	"./60.3.TP.png": "bb32",
	"./60.4.NH3-N.png": "984b",
	"./60.5.COD.png": "bfab",
	"./60.6.CODm.png": "dea8",
	"./60.7.Chla.png": "4aef",
	"./60.8.TSS.png": "b0ec",
	"./60.9.TU.png": "b0a1",
	"./61.1.jpg": "70f8",
	"./61.10.pH.png": "42a1",
	"./61.2.TN.png": "8db7",
	"./61.3.TP.png": "f248",
	"./61.4.NH3-N.png": "caf7",
	"./61.5.COD.png": "7edb",
	"./61.6.CODm.png": "9da0",
	"./61.7.Chla.png": "d101",
	"./61.8.TSS.png": "db48",
	"./61.9.TU.png": "1a1c",
	"./62.1.jpg": "0216",
	"./62.10.pH.png": "0727",
	"./62.2.TN.png": "665c",
	"./62.3.TP.png": "7ab7",
	"./62.4.NH3-N.png": "7beb",
	"./62.5.COD.png": "3fb4",
	"./62.6.CODm.png": "ba26",
	"./62.7.Chla.png": "26a3",
	"./62.8.TSS.png": "1178",
	"./62.9.TU.png": "a6d7",
	"./63.1.jpg": "a3c7",
	"./63.10.TU.png": "5386",
	"./63.2.TN.png": "1356",
	"./63.3.TP.png": "1576",
	"./63.4.NH3-N.png": "5ff8",
	"./63.5.COD.png": "c865",
	"./63.6.CODm.png": "1f8d",
	"./63.7.Chla.png": "fefb",
	"./63.8.TSS.png": "bcfe",
	"./63.9.pH.png": "2a07",
	"./64.1.jpg": "61bb",
	"./64.10.pH.png": "991b",
	"./64.2.TN.png": "3a01",
	"./64.3.TP.png": "f06a",
	"./64.4.NH3-N.png": "ed60",
	"./64.5.COD.png": "ce77",
	"./64.6.CODm.png": "d135",
	"./64.7.Chla.png": "f347",
	"./64.8.TSS.png": "14c6",
	"./64.9.TU.png": "0152",
	"./65.1.jpg": "627a",
	"./65.10.pH.png": "7e7b",
	"./65.2.TN.png": "fe9f",
	"./65.3.TP.png": "6e0d",
	"./65.4.NH3-N.png": "cbe0",
	"./65.5.COD.png": "ee2d",
	"./65.6.CODm.png": "7ab1",
	"./65.7.Chla.png": "2b8d",
	"./65.8.TSS.png": "e5a1",
	"./65.9.TU.png": "e845",
	"./66.1.jpg": "8a8d",
	"./66.10.pH.png": "da53",
	"./66.2.TN.png": "6156",
	"./66.3.TP.png": "609e",
	"./66.4.NH3-N.png": "3b72",
	"./66.5.COD.png": "1fbd",
	"./66.6.CODm.png": "a08d",
	"./66.7.Chla.png": "537c",
	"./66.8.TSS.png": "419e",
	"./66.9.TU.png": "ba47",
	"./67.1.jpg": "0e33",
	"./67.10.pH.png": "a04e",
	"./67.2.TN.png": "6a97",
	"./67.3.TP.png": "13c3",
	"./67.4.NH3-N.png": "c6a3",
	"./67.5.COD.png": "7290",
	"./67.6.CODm.png": "b97c",
	"./67.7.Chla.png": "f550",
	"./67.8.TSS.png": "833c",
	"./67.9.TU.png": "8d3e",
	"./68.1.jpg": "e441",
	"./68.10.pH.png": "5de6",
	"./68.2.TN.png": "e32b",
	"./68.3.TP.png": "4276",
	"./68.4.NH3-N.png": "df68",
	"./68.5.COD.png": "3d34",
	"./68.6.CODm.png": "7d63",
	"./68.7.Chla.png": "bcb2",
	"./68.8.TSS.png": "54fa",
	"./68.9.TU.png": "a2b5",
	"./69.1.jpg": "bfce",
	"./69.10.pH.png": "f092",
	"./69.2.TN.png": "dd10",
	"./69.3.TP.png": "8f17",
	"./69.4.NH3-N.png": "47d5",
	"./69.5.COD.png": "f709",
	"./69.6.CODm.png": "697b",
	"./69.7.Chla.png": "c68f",
	"./69.8.TSS.png": "afee",
	"./69.9.TU.png": "386e",
	"./7.1.jpg": "5170",
	"./7.10.pH.png": "68f6",
	"./7.2.TN.png": "1015",
	"./7.3.TP.png": "4ece",
	"./7.4.NH3-N.png": "e02c",
	"./7.5.COD.png": "8048",
	"./7.6.CODm.png": "85f2",
	"./7.7.Chla.png": "dd47",
	"./7.8.TSS.png": "45a1",
	"./7.9.TU.png": "2d4f",
	"./70.1.jpg": "eef8",
	"./70.10.pH.png": "d9ac",
	"./70.2.TN.png": "4e44",
	"./70.3.TP.png": "1262",
	"./70.4.NH3-N.png": "4746",
	"./70.5.COD.png": "a03b",
	"./70.6.CODm.png": "6a84",
	"./70.7.Chla.png": "a143",
	"./70.8.TSS.png": "dd73",
	"./70.9.TU.png": "00ff",
	"./71.1.jpg": "02bf",
	"./71.10.pH.png": "b2f3",
	"./71.2.TN.png": "0725",
	"./71.3.TP.png": "fd66",
	"./71.4.NH3-N.png": "ee5e",
	"./71.5.COD.png": "414a",
	"./71.6.CODm.png": "a47d",
	"./71.7.Chla.png": "4b8c",
	"./71.8.TSS.png": "f095",
	"./71.9.TU.png": "3bd0",
	"./72.1.jpg": "c29f",
	"./72.10.pH.png": "70a1",
	"./72.2.TN.png": "3e8b",
	"./72.3.TP.png": "9ab2",
	"./72.4.NH3-N.png": "ff62",
	"./72.5.COD.png": "debb",
	"./72.6.CODm.png": "f4e7",
	"./72.7.Chla.png": "d2b6",
	"./72.8.TSS.png": "d452",
	"./72.9.TU.png": "c0a2",
	"./73.1.jpg": "3d8f",
	"./73.10.pH.png": "846d",
	"./73.2.TN.png": "4fbf",
	"./73.3.TP.png": "c11d",
	"./73.4.NH3-N.png": "5f16",
	"./73.5.COD.png": "c978",
	"./73.6.CODm.png": "0fd8",
	"./73.7.Chla.png": "1298",
	"./73.8.TSS.png": "4c74",
	"./73.9.TU.png": "e1c0",
	"./74.1.jpg": "27cc",
	"./74.10.pH.png": "82cf",
	"./74.2.TN.png": "096d",
	"./74.3.TP.png": "2ac9",
	"./74.4.NH3-N.png": "281f",
	"./74.5.COD.png": "ab19",
	"./74.6.CODm.png": "1b90",
	"./74.7.Chla.png": "68a0",
	"./74.8.TSS.png": "9da8",
	"./74.9.TU.png": "96e3",
	"./75.1.jpg": "da88",
	"./75.10.pH.png": "1420",
	"./75.2.TN.png": "7d6b",
	"./75.3.TP.png": "19f6",
	"./75.4.NH3-N.png": "73e3",
	"./75.5.COD.png": "54e4",
	"./75.6.CODm.png": "ccc0",
	"./75.7.Chla.png": "3e56",
	"./75.8.TSS.png": "1c17",
	"./75.9.TU.png": "8610",
	"./76.1.jpg": "5897",
	"./76.10.pH.png": "c93b",
	"./76.2.TN.png": "2083",
	"./76.3.TP.png": "1944",
	"./76.4.NH3-N.png": "437c",
	"./76.5.COD.png": "194c",
	"./76.6.CODm.png": "00b0",
	"./76.7.Chla.png": "aeb2",
	"./76.8.TSS.png": "de9e",
	"./76.9.TU.png": "e764",
	"./77.1.jpg": "2fa0",
	"./77.10.pH.png": "0f05",
	"./77.2.TN.png": "8f1c",
	"./77.3.TP.png": "e2b8",
	"./77.4.NH3-N.png": "05f0",
	"./77.5.COD.png": "3b67",
	"./77.6.CODm.png": "26f9",
	"./77.7.Chla.png": "ca8e",
	"./77.8.TSS.png": "0da3",
	"./77.9.TU.png": "af8b",
	"./78.1.jpg": "6fb9",
	"./78.10.pH.png": "9fbc",
	"./78.2.TN.png": "4888",
	"./78.3.TP.png": "a60d",
	"./78.4.NH3-N.png": "19fc",
	"./78.5.COD.png": "c39f",
	"./78.6.CODm.png": "9de5",
	"./78.7.Chla.png": "f6cc",
	"./78.8.TSS.png": "2acb",
	"./78.9.TU.png": "1224",
	"./79.1.jpg": "4dd6",
	"./79.10.pH.png": "e0de",
	"./79.2.TN.png": "7236",
	"./79.3.TP.png": "055b",
	"./79.4.NH3-N.png": "2f98",
	"./79.5.COD.png": "0a8b",
	"./79.6.CODm.png": "7beb0",
	"./79.7.Chla.png": "6a8b",
	"./79.8.TSS.png": "5127",
	"./79.9.TU.png": "e0fa",
	"./8.1.jpg": "68f69",
	"./8.10.pH.png": "80a3",
	"./8.2.TN.png": "2870",
	"./8.3.TP.png": "634b",
	"./8.4.NH3-N.png": "cef2",
	"./8.5.COD.png": "1c81",
	"./8.6.CODm.png": "89b9",
	"./8.7.Chla.png": "3706",
	"./8.8.TSS.png": "b6ac",
	"./8.9.TU.png": "219b",
	"./80.1.jpg": "d455",
	"./80.10.pH.png": "b771",
	"./80.2.TN.png": "e46b5",
	"./80.3.TP.png": "7c08",
	"./80.4.NH3-N.png": "8d80",
	"./80.5.COD.png": "e954",
	"./80.6.CODm.png": "6208",
	"./80.7.Chla.png": "33f2",
	"./80.8.TSS.png": "cff0",
	"./80.9.TU.png": "498c",
	"./81.1.jpg": "9ec0",
	"./81.10.pH.png": "1cf0",
	"./81.2.TN.png": "b4ba",
	"./81.3.TP.png": "b6dd",
	"./81.4.NH3-N.png": "10a6",
	"./81.5.COD.png": "1eff",
	"./81.6.CODm.png": "9d3c",
	"./81.7.Chla.png": "5c63",
	"./81.8.TSS.png": "be0b",
	"./81.9.TU.png": "1af5",
	"./82.1.jpg": "06c0",
	"./82.10.pH.png": "ee42",
	"./82.2TN.png": "ac88",
	"./82.3.TP.png": "56c1",
	"./82.4.NH3-N.png": "d237",
	"./82.5.COD.png": "6a5a",
	"./82.6.CODm.png": "696b",
	"./82.7.Chla.png": "5706",
	"./82.8.TSS.png": "1083",
	"./82.9.TU.png": "16ed",
	"./83.1.jpg": "e34c",
	"./83.10.pH.png": "2a74",
	"./83.2.TN.png": "6b89",
	"./83.3.TP.png": "6acc",
	"./83.4.NH3-N.png": "7ea7",
	"./83.5.COD.png": "3d99",
	"./83.6.CODm.png": "659d",
	"./83.7.Chla.png": "8247",
	"./83.8.TSS.png": "9b09",
	"./83.9.TU.png": "e847",
	"./84.1.jpg": "1ca3",
	"./84.10.pH.png": "bbb9",
	"./84.2.TN.png": "328d",
	"./84.3.TP.png": "d6be",
	"./84.4.NH3-N.png": "34f9",
	"./84.5.COD.png": "ae72",
	"./84.6.CODm.png": "94df",
	"./84.7.Chla.png": "8a8c9",
	"./84.8.TSS.png": "4e02",
	"./84.9.TU.png": "4b7a",
	"./85.1.jpg": "ab27",
	"./85.10.pH.png": "02f2",
	"./85.2.TN.png": "dcf0",
	"./85.3.TP.png": "f96e",
	"./85.4.NH3-N.png": "22d7",
	"./85.5.COD.png": "af28",
	"./85.6.CODm.png": "99a7",
	"./85.7.Chla.png": "8542",
	"./85.8.TSS.png": "1553",
	"./85.9.TU.png": "09ad",
	"./86.1.jpg": "99f0",
	"./86.10.pH.png": "624f",
	"./86.2.TN.png": "b593",
	"./86.3.TP.png": "3990",
	"./86.4.NH3-N.png": "b39f",
	"./86.5.COD.png": "5a7d",
	"./86.6.CODm.png": "45f6",
	"./86.7.Chla.png": "8a420",
	"./86.8.TSS.png": "3337",
	"./86.9.TU.png": "ee83",
	"./87.1.jpg": "c9f8",
	"./87.10.pH.png": "578c",
	"./87.2.TN.png": "a4e5",
	"./87.3.TP.png": "744e",
	"./87.4.NH3-N.png": "abfe",
	"./87.5.COD.png": "8afe",
	"./87.6.CODm.png": "70bd",
	"./87.7.Chla.png": "6e3d",
	"./87.8.TSS.png": "bb3f",
	"./87.9.TU.png": "8ed4",
	"./88.1.jpg": "0de4",
	"./88.10.pH.png": "b80b",
	"./88.2.TN.png": "a725",
	"./88.3.TP.png": "8728c",
	"./88.4.NH3-N.png": "7524",
	"./88.5.COD.png": "4dd0",
	"./88.6.CODm.png": "c0bf",
	"./88.7.Chla.png": "a1d4",
	"./88.8.TSS.png": "b08f",
	"./88.9.TU.png": "8139",
	"./89.1.jpg": "150b",
	"./89.10.pH.png": "7659",
	"./89.2.TN.png": "9a02",
	"./89.3.TP.png": "2375",
	"./89.4.NH3-N.png": "6145",
	"./89.5.COD.png": "38a1",
	"./89.6.CODm.png": "21cb",
	"./89.7.Chla.png": "f21b",
	"./89.8.TSS.png": "207b",
	"./89.9.TU.png": "36f1",
	"./9.1.jpg": "8914",
	"./9.10.pH.png": "dd3a",
	"./9.2.TN.png": "9e36",
	"./9.3.TP.png": "ef2a0",
	"./9.4.NH3-N.png": "3a81",
	"./9.5.COD.png": "05d9",
	"./9.6.CODm.png": "0361",
	"./9.7.Chla.png": "30c2",
	"./9.8.TSS.png": "302e",
	"./9.9.TU.png": "af5e",
	"./90.1.jpg": "f911",
	"./90.10.pH.png": "fe3f",
	"./90.2.TN.png": "545f",
	"./90.3.TP.png": "e4aa",
	"./90.4.NH3-N.png": "08a8",
	"./90.5.COD.png": "da05",
	"./90.6.CODm.png": "b222",
	"./90.7.Chla.png": "2508",
	"./90.8.TSS.png": "7d73",
	"./90.9.TU.png": "2702",
	"./91.1.jpg": "174e",
	"./91.10.pH.png": "a593",
	"./91.2.TN.png": "4277",
	"./91.3.TP.png": "5fa9",
	"./91.4.NH3-N.png": "ae9e",
	"./91.5.COD.png": "eb0d",
	"./91.6.CODm.png": "185d",
	"./91.7.Chla.png": "1cdb",
	"./91.8.TSS.png": "b9d7",
	"./91.9.TU.png": "a3c3",
	"./92.1.jpg": "433e",
	"./92.10.pH.png": "1b97",
	"./92.2.TN.png": "3cbf",
	"./92.3.TP.png": "9fc7",
	"./92.4.NH3-N.png": "1da13",
	"./92.5.COD.png": "959d",
	"./92.6.CODm.png": "4eee",
	"./92.7.Chla.png": "fb79",
	"./92.8.TSS.png": "c31c",
	"./92.9.TU.png": "e890",
	"./93.1.jpg": "d081",
	"./93.10.pH.png": "5138",
	"./93.2.TN.png": "9d9b",
	"./93.3.TP.png": "c7b2",
	"./93.4.NH3-N.png": "56d1",
	"./93.5.COD.png": "8cc1",
	"./93.6.CODm.png": "d148",
	"./93.7.Chla.png": "699a",
	"./93.8.TSS.png": "af02",
	"./93.9.TU.png": "a3e2",
	"./94.1.jpg": "9d70",
	"./94.10.pH.png": "61c5",
	"./94.2.TN.png": "d56e",
	"./94.3.TP.png": "e943",
	"./94.4.NH3-N.png": "a55b3",
	"./94.5.COD.png": "144b",
	"./94.6.CODm.png": "d82c",
	"./94.7.Chla.png": "9741",
	"./94.8.TSS.png": "0c37",
	"./94.9.TU.png": "137e",
	"./95.1.jpg": "476c",
	"./95.10.pH.png": "45be",
	"./95.2.TN.png": "a49c",
	"./95.3.TP.png": "162a",
	"./95.4.NH3-N.png": "13a9",
	"./95.5.COD.png": "9a30",
	"./95.6.CODm.png": "b5b1",
	"./95.7.Chla.png": "fdeb",
	"./95.8.TSS.png": "3827",
	"./95.9.TU.png": "6d6d",
	"./96.1.jpg": "be1b",
	"./96.10.pH.png": "3f5a",
	"./96.2.TN.png": "bdbf",
	"./96.3.TP.png": "9fc2",
	"./96.4.NH3-N.png": "5776",
	"./96.5.COD.png": "7ae4",
	"./96.6.CODm.png": "7f07",
	"./96.7.Chla.png": "32c9",
	"./96.8.TSS.png": "39eb",
	"./96.9.TU.png": "4e43",
	"./97.1.jpg": "7c9d",
	"./97.10.png": "45dd",
	"./97.2.png": "2ce4",
	"./97.3.png": "c87c",
	"./97.4.png": "ffb5",
	"./97.5.png": "9726",
	"./97.6.png": "f392",
	"./97.7.png": "eeb0",
	"./97.8.png": "b110",
	"./97.9.png": "6d6c",
	"./98.1.jpg": "01b2",
	"./98.10.png": "b2a0",
	"./98.2.png": "45e4",
	"./98.3.png": "2ac98",
	"./98.4.png": "5250",
	"./98.5.png": "8b91",
	"./98.6.png": "9407",
	"./98.7.png": "6db0",
	"./98.8.png": "96a6",
	"./98.9.png": "d616",
	"./99.1.jpg": "117b",
	"./99.10.png": "9414",
	"./99.2.png": "aa38",
	"./99.3.png": "3ba5",
	"./99.4.png": "4a5d",
	"./99.5.png": "f00d",
	"./99.6.png": "a402",
	"./99.7.png": "600c",
	"./99.8.png": "a9de",
	"./99.9.png": "f0a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2dee";